import { Http } from '@angular/http';
import { Component } from '@angular/core';
import { NavController, LoadingController, PopoverController, NavParams, ModalController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { ViewContactPage } from '../view-contact/view-contact';
import { LoadingProvider } from '../../providers/loading/loading';

@Component({
  selector: 'page-deleted-records',
  templateUrl: 'deleted-records.html',
})
export class DeletedRecordsPage {
  
  public deletedContacts: any;
  public deletedRealestates: any;
  public deletedIncomes: any;
  public deletedAssets: any;
  public deletedLiabilities: any;
  public loading: any;

  constructor(
    public navCtrl: NavController,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public loadingCtrl: LoadingController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private firestore: AngularFirestore,
    public http: Http
  ) {
    this.getAllDeletedContacts().subscribe((data)=>{
      if(data.length > 0){
        this.deletedContacts = data;
      }else{

      }
    });
    this.getAllDeletedRealestates().subscribe((data)=>{
      if(data.length > 0){
        this.deletedRealestates = data;
      }else{

      }
    });
    this.getAllDeletedIncomes().subscribe((data)=>{
      if(data.length > 0){
        this.deletedIncomes = data;
      }else{

      }
    });
    this.getAllDeletedAssets().subscribe((data)=>{
      if(data.length > 0){
        this.deletedAssets = data;
      }else{

      }
    });
    this.getAllDeletedLiabilities().subscribe((data)=>{
      if(data.length > 0){
        this.deletedLiabilities = data;
      }else{

      }
    });
  }

  presentLoadingText(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading Please Wait...'
    });

    this.loading.present();
  }

  getAllDeletedContacts (){
    return this.db.collection<any>( "users" , ref => ref.where( 'deleted', '==', 1 ).orderBy('deleted_date', 'desc')).valueChanges ();
  }

  getAllDeletedRealestates (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where( 'deleted', '==', 1 ).orderBy('deleted_date', 'desc')).valueChanges ();
  }

  getAllDeletedIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where( 'deleted', '==', 1 ).orderBy('deleted_date', 'desc')).valueChanges ();
  }

  getAllDeletedAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where( 'deleted', '==', 1 ).orderBy('deleted_date', 'desc')).valueChanges ();
  }

  getAllDeletedLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where( 'deleted', '==', 1 ).orderBy('deleted_date', 'desc')).valueChanges ();
  }

  viewRecord(event, contact_uid){
    this.navCtrl.push(ViewContactPage,{
      contact_uid:contact_uid
      });
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      console.log(e)
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/deleted-records/deleted-records.ts